import ArrowSeparator from "./ArrowSeparator";

export default ArrowSeparator;
